import React from 'react';
import { withDashboardLayout } from 'layouts/DashboardLayout/DashboardLayout';
import PageContainer from 'components/PageContainer/PageContainer';
import UploadShipments from 'components/UploadShipments/UploadShipments';
import useFileTypeUploadWarning from 'hooks/useFileTypeUploadWarning';

function UploadSATPage() {
  const group = useFileTypeUploadWarning('sat');

  return (
    <PageContainer title="Subida de archivos de SAT Reparaciones">
      <UploadShipments group={group} />
    </PageContainer>
  );
}

export default withDashboardLayout(UploadSATPage);
